import React, { useEffect } from 'react'

import { useQueryClient } from '@tanstack/react-query'
import { Navigate } from 'react-router'

import { useAuth } from '@/hooks/use-auth'
import { AppSidebar } from '@/layouts/app-sidebar'
import { EmConstrucaoPage } from '@/pages/em-construcao/em-construcao'
import { SemPerfilPage } from '@/pages/sem-perfil/sem-perfil'

export const PrivateRoute: React.FC = () => {
  const {
    user,
    state: { isAuthenticated },
  } = useAuth()
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!user?.unidadeDeNegocioId) return
    queryClient.invalidateQueries()
  }, [queryClient, user?.unidadeDeNegocioId])

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  switch (user?.perfilDoUsuario) {
    case 'Recepcionista':
      return <EmConstrucaoPage nome={user.nome} />
    case 'AdministradorDaPlataforma':
    case 'AssessorImobiliario':
    case 'GerenteDeVendas':
    case 'Prospector':
    case 'Vendedor':
      return <AppSidebar />
    default:
      return <SemPerfilPage />
  }
}
